module.exports = new __parcel__URL__("cornershop-landing.9b2bead9.webp").toString();